var map = {
	"assets/images/relics/WAR/relic_weapon-g_w_resistance-p_w_blade.png": 2838,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_animus.png": 3873,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_atma.png": 2728,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_base_weapon.png": 1197,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_braves.png": 8250,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_nexus.png": 5097,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_novus.png": 1082,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_zenith.png": 6057,
	"assets/images/relics/WAR/relic_weapon-g_w_zodiac-p_w_zeta.png": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;